import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import LogoutModal from '@common/component/organisms/LogoutModal';
import { UserState } from '@common/redux/reducers/UserReducer';
import { actions } from '@common/redux/modules/Actions';
import { SORRY_MESSAGE_TYPE } from '@common/redux/reducers/SorryMessageReducer';
import Cookies from 'js-cookie';
import { AgencyAppState } from 'src/redux/modules/store';
import * as SessionApi from '@common/external/SessionApi';
import { SessionRequest } from '@common/external/SessionApi';
import { API_RESULT_CD } from '@common/external/Common';

const auth0LogoutUrl = process.env.REACT_APP_AUTH0_LOGOUT_URL || '';

const mapStateToProps = (appState: AgencyAppState) => {
  return {
    loginUser: appState.loginUser,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    logout: (loginUser: UserState, history: any) => {
      logout(loginUser, history, dispatch);
    },
  };
};

export async function logout(loginUser: UserState, history: any, dispatch: Dispatch): Promise<void> {

  //STEP1
  // backend経由でDBからsession情報を削除する
  const request:SessionRequest = {userId:loginUser.crewCd}

  const result = await deleteSession(request);
  if (result === API_RESULT_CD.OK || result === API_RESULT_CD.SESSION_NO_EXIST) {
    //STEP2
    // cookieからsession情報を削除する
    deleteCookie();

    //STEP3
    // Auth0ログアウト画面へ遷移させる
    redirectAuth0Logout();
  } else if (result === API_RESULT_CD.OLD_SESSION) {
    //タイムアウト
    // sorry(ログアウト)画面へ遷移させる
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.LOGIN_FAILED));
    redirectSorryPage(history);
  } else if (result === API_RESULT_CD.ERROR) {
    //システムエラー
    // sorry(ログアウト)画面へ遷移させる
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
    redirectSorryPage(history);
  } else {
    //不正なアクセス
    // sorry(ログアウト)画面へ遷移させる
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.BAD_ACCESS));
    redirectSorryPage(history);
  }
}

async function deleteSession(request: SessionRequest): Promise<string> {
  return await SessionApi.removeSession(request);
}

export function redirectSorryPage(history: any): void {
  history.replace('/sorry');
}

export function redirectAuth0Logout(): void {
  console.log('calling window.location');
  window.location.replace(auth0LogoutUrl);
}

function deleteCookie():void{
  Object.keys(Cookies.get()).forEach(function(cookieName) {
    Cookies.remove(cookieName);
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutModal);
